import React, { useEffect, useMemo, useState } from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link, useLocation } from "react-router-dom";

// Import services
import {
  fetchDetailProduks,
  createDetailProduk,
  updateDetailProduk,
  deleteDetailProduk,
} from '../../../services/detailProdukService';
import { fetchProduks } from '../../../services/produkService';

// Import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import DeleteModal from '../../../components/Common/DeleteModal';

const DetailProduk = () => {
  // Meta title
  document.title = "Detail Produk";

  // Get query params
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idProduk = queryParams.get('id_produk');

  // --- START: Added validation for missing id_produk ---

  // --- END: Added validation for missing id_produk ---


  // State management
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [detailProduk, setDetailProduk] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingProdukOptions, setLoadingProdukOptions] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  });
  const [filters, setFilters] = useState({
    detail_name: "",
    available: "",
    id_produk: idProduk || "", // Initialize with idProduk from URL if available
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [produkOptions, setProdukOptions] = useState([]);

  // Handle delete modal
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setDetailProduk(null);
  };

  const handleConfirmDelete = async () => {
    try {
      if (detailProduk && detailProduk.id_detail_produk) {
        const response = await deleteDetailProduk(detailProduk.id_detail_produk);
        if (response.success) {
          toast.success("Detail produk berhasil dihapus");
          fetchData(pagination.page, pagination.per_page, filters);
        } else {
          toast.error(response.message || "Gagal menghapus detail produk");
        }
      }
    } catch (error) {
      console.error("Error deleting detail produk:", error);
      toast.error(error.message || "Gagal menghapus detail produk");
    } finally {
      handleCloseDeleteModal();
    }
  };

  // Fetch data
const fetchData = async (page = 1, per_page = 10, filterParams = {}) => {
  try {
    setLoading(true);
    const response = await fetchDetailProduks({
      page,
      per_page,
      filters: filterParams
    });

    console.log('API Response:', response); // Untuk debugging

    // Hitung last_page jika tidak disediakan oleh backend
    const total = response.meta?.total || 0;
    const calculatedPerPage = response.meta?.per_page || per_page;
    const last_page = Math.ceil(total / calculatedPerPage);

    setData(response.data || []);
    setPagination({
      page: response.meta?.page || 1,
      per_page: calculatedPerPage,
      total: total,
      last_page: last_page // Gunakan nilai yang dihitung
    });
  } catch (error) {
    console.error("Error in fetchData:", error);
    toast.error("Gagal memuat data detail produk");
  } finally {
    setLoading(false);
  }
};

  const fetchProdukOptions = async () => {
    try {
      setLoadingProdukOptions(true);
      const response = await fetchProduks({ disable_pagination: true });

      if (response && response.data) {
        setProdukOptions(response.data);
      } else {
        toast.error("Gagal memuat opsi produk: struktur respons tidak valid");
      }
    } catch (error) {
      console.error("Error fetching produk options:", error);
      toast.error("Terjadi kesalahan saat memuat opsi produk.");
    } finally {
      setLoadingProdukOptions(false);
    }
  };

  // Form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id_produk: detailProduk?.id_produk || (idProduk || ""), // Pre-fill from existing data or URL param
      detail_name: detailProduk?.detail_name || "",
      available: detailProduk?.available === true || false,
    },

    validationSchema: Yup.object({
      id_produk: Yup.string().required("Produk wajib dipilih"),
      detail_name: Yup.string().required("Nama detail wajib diisi"),
    }),

    onSubmit: async (values) => {
      try {
        const formData = {
          id_produk: values.id_produk,
          detail_name: values.detail_name,
          available: values.available ? "1" : "0",
        };

        let response;
        if (isEdit) {
          response = await updateDetailProduk(detailProduk.id_detail_produk, formData);
        } else {
          response = await createDetailProduk(formData);
        }

        if (response.success) {
          toast.success(response.message || (isEdit ? "Detail produk berhasil diperbarui" : "Detail produk berhasil ditambahkan"));
          setModal(false);
          fetchData(pagination.page, pagination.per_page, filters);
        } else {
          if (response.errors) {
            // Display specific validation errors from the backend
            Object.keys(response.errors).forEach(key => {
              response.errors[key].forEach(msg => {
                toast.error(`${key}: ${msg}`);
              });
            });
          } else {
            toast.error(response.message || "Gagal menyimpan detail produk");
          }
        }
      } catch (error) {
        console.error("Error in form submission:", error);
        toast.error("Terjadi kesalahan saat menyimpan data.");
      }
    },
  });

  // Effects
useEffect(() => {
  fetchData(1, pagination.per_page, filters); 
}, [filters]); 

  // Handlers
const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({
    ...prev,
    [name]: value
  }));
  // Tidak perlu memanggil fetchData di sini karena sudah dihandle oleh useEffect
};

  const clearFilters = () => {
    const defaultFilters = {
      detail_name: "",
      available: "",
      id_produk: idProduk || "", // Reset to idProduk from URL or empty
    };
    setFilters(defaultFilters);
    // fetchData(1, pagination.per_page, defaultFilters); // fetchData is called in useEffect when filters change
  };

  const openAddModal = () => {
    setDetailProduk(null);
    setIsEdit(false);
    validation.resetForm();
    // Ensure id_produk from URL is pre-filled when adding
    if (idProduk) {
      validation.setFieldValue("id_produk", idProduk);
    }
    setModal(true);
  };

  const openEditModal = (detailData) => {
    setDetailProduk(detailData);
    setIsEdit(true);
    validation.setValues({
      id_produk: detailData.id_produk || (idProduk || ""), // Prefer detailData's id_produk, fallback to URL
      detail_name: detailData.detail_name || "",
      available: detailData.available === "1",
    });
    setModal(true);
  };

  const onClickDelete = (detailData) => {
    setDetailProduk(detailData);
    setDeleteModal(true);
  };

  // Columns
  const columns = useMemo(
    () => [
      {
        header: "Nama Produk",
        accessorKey: "nama_produk",
        enableColumnFilter: false,
        cell: (cellProps) => {
          return cellProps.row.original.nama_produk || "-";
        }
      },
      {
        header: "Nama Detail",
        accessorKey: "detail_name",
        enableColumnFilter: false,
      },
      {
        header: "Tersedia",
        accessorKey: "available",
        enableColumnFilter: false,
        cell: (cellProps) => {
        const value = cellProps.getValue();
        const isAvailable = value === true || value === "true" || value === "1";
        return (
            <span className={`badge bg-${isAvailable ? "success" : "danger"}`}>
            {isAvailable ? "Ya" : "Tidak"}
            </span>
        );
        }

      },
      {
        header: 'Created At',
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cellProps) => {
          const rawDate = cellProps.getValue();
          if (rawDate && rawDate !== "0001-01-01T00:00:00Z") {
            const date = new Date(rawDate);
            if (!isNaN(date.getTime())) {
              return date.toISOString().split('T')[0];
            }
          }
          return "-";
        }
      },
      {
        header: 'Action',
        enableColumnFilter: false,
        cell: (cellProps) => (
          <div className="hstack gap-2">
            <Link
  to="#"
  className="btn btn-sm btn-soft-info"
  onClick={(e) => {
    e.preventDefault(); // cegah perubahan URL
    openEditModal(cellProps.row.original);
  }}
  id={`edittooltip-${cellProps.row.original.id_detail_produk}`}
>
  <i className="mdi mdi-pencil-outline" />
  <UncontrolledTooltip
    placement="top"
    target={`edittooltip-${cellProps.row.original.id_detail_produk}`}
  >
    Edit
  </UncontrolledTooltip>
</Link>

            <Link
              to="#"
              className="btn btn-sm btn-soft-danger"
              onClick={() => onClickDelete(cellProps.row.original)}
              id={`deletetooltip-${cellProps.row.original.id_detail_produk}`}
            >
              <i className="mdi mdi-delete-outline" />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id_detail_produk}`}>
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        )
      }
    ],
    []
  );

  // Custom Pagination
const CustomPagination = () => {
  const { page, last_page, total, per_page } = pagination;

  // Baris ini telah dihapus agar paginasi selalu muncul
  // if (last_page <= 1) return null;

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= last_page && newPage !== page) {
      fetchData(newPage, per_page, filters);
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-4">
      <div className="text-muted">
        Menampilkan <span className="fw-semibold">{((page - 1) * per_page) + 1}</span> sampai{' '}
        <span className="fw-semibold">{Math.min(page * per_page, total)}</span> dari total{' '}
        <span className="fw-semibold">{total}</span> entri
      </div>

      <div className="d-flex align-items-center">
        <Pagination className="pagination pagination-rounded mb-0">
          {/* Previous Button */}
          <PaginationItem disabled={page === 1}>
            <PaginationLink previous onClick={() => handlePageChange(page - 1)} />
          </PaginationItem>

          {/* Page Numbers - selalu render minimal 2 halaman jika ada lebih dari 1 halaman */}
          {Array.from({ length: last_page }, (_, i) => i + 1).map(pageNum => (
            <PaginationItem key={pageNum} active={pageNum === page}>
              <PaginationLink onClick={() => handlePageChange(pageNum)}>
                {pageNum}
              </PaginationLink>
            </PaginationItem>
          ))}

          {/* Next Button */}
          <PaginationItem disabled={page === last_page}>
            <PaginationLink next onClick={() => handlePageChange(page + 1)} />
          </PaginationItem>
        </Pagination>
      </div>
    </div>
  );
};

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleConfirmDelete}
        onCloseClick={handleCloseDeleteModal}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs 
            title="Master Data" 
            breadcrumbItem={idProduk ? "Detail Produk" : "Master Detail Produk"} 
          />
          {
            loading ? <Spinners setLoading={setLoading} />
              :
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center justify-content-between">
                      <h5 className="mb-0 card-title flex-grow-1">
                        {idProduk ? `List Detail Produk untuk Produk ID: ${idProduk}` : "List Semua Detail Produk"}
                      </h5>
                      <div className="d-flex align-items-center">
                        <Button color="primary" onClick={openAddModal}>
                          <i className="mdi mdi-plus me-1"></i>
                          Tambah
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                  <CardBody>
            

                    <TableContainer
                      columns={columns}
                      data={data}
                      isGlobalFilter={false}
                      isPagination={false}
                      customPageSize={pagination.per_page}
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    />
                    <CustomPagination />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }

          {/* Modal for Add/Edit Detail Produk */}
          <Modal isOpen={modal} toggle={() => setModal(false)}>
            <ModalHeader toggle={() => setModal(false)} tag="h4">
              {isEdit ? "Edit Detail Produk" : "Tambah Detail Produk"}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={validation.handleSubmit}>

                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label>Nama Detail</Label>
                      <Input
                        name="detail_name"
                        type="text"
                        placeholder="Nama Detail Produk"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.detail_name || ""}
                        invalid={!!(validation.touched.detail_name && validation.errors.detail_name)}
                      />
                      <FormFeedback>{validation.errors.detail_name}</FormFeedback>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <FormGroup check className="mb-3">
                        <Input
                        type="checkbox"
                        className="form-check-input"
                        name="available"
                        id="available"
                        checked={validation.values.available === true || validation.values.available === "1"}
                        onChange={(e) => validation.setFieldValue("available", e.target.checked)}
                        />

                      <Label htmlFor="available" className="form-check-label">Tersedia</Label>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="primary">
                        {isEdit ? "Update" : "Tambah"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default DetailProduk;